import React from "react";
import { Route } from "react-router-dom";
import Admission from "../pages/Admission";
import ScheduleGuidline from "../page_content/AdmissionsSection/schedule_guidline/ScheduleGuid";
import AdmissionProc from "../page_content/AdmissionsSection/admission_process/AdmissionProc";
import NewAdmission from "../page_content/AdmissionsSection/new_admission/NewAdmission";
import CourseEligibilty from "../page_content/AdmissionsSection/course_eligibilty/CourseEligibilty";
// import DNS from "../page_content/AdmissionsSection/DNS/DNS";
import Scholarships from "../page_content/AdmissionsSection/scholarships/Scholarships";
import FeeStructure from "../page_content/AdmissionsSection/fee_structure/FeeStructure";
import AdmissionFAQ from "../page_content/AdmissionsSection/admission_faq/AdmissionFAQ";
import ApplicationForm from "../page_content/AdmissionsSection/application_form/ApplicationForm";
import Brochure from "../page_content/AdmissionsSection/brochure/Brochure";

export const AdmissionsRoutes = (
  <Route path="admissions" element={<Admission />}>
    <Route path="admission-2026" element={<NewAdmission />} />
    <Route path="application-form" element={<ApplicationForm />} />
    <Route path="admission-procedure" element={<AdmissionProc />} />
    <Route path="course-eligibilty" element={<CourseEligibilty />} />
    {/* <Route path="DNS" element={<DNS />} /> */}
    <Route path="schedule-guidline" element={<ScheduleGuidline />} />
    <Route path="scholarships" element={<Scholarships />} />
    <Route path="fee-structure" element={<FeeStructure />} />
    <Route path="brochure" element={<Brochure />} />
    <Route path="admission-faq" element={<AdmissionFAQ />} />
  </Route>
);
